import { PORT } from '@repo/sdk'

export const API_URL
  = (import.meta.env as { VITE_API_URL?: string }).VITE_API_URL
    || `http://localhost:${PORT.API}`

// For development, also support direct environment variables
export const WEB_ADMIN_PORT = PORT.WEB_ADMIN
